module.exports = __webpack_public_path__ + "img/banner-home@2x.830588c1.png";